import {Button, Form, Grid, Header, Input, Segment} from 'semantic-ui-react'
import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import React from 'react'
import 'rc-time-picker/assets/index.css';
import {ppTypes, tripHours, vehicleTypes} from "../misc/Helpers";
import {tripMins} from "../misc/Helpers";

function ReportForm({
                      vehicleType,
                      pp,
                      tripDate,
                      startHour,
                      startMin,
                      firstBorderHour,
                      firstBorderMin,
                      secondBorderHour,
                      secondBorderMin,
                      total,
                      notes,
                      handleInputChange,
                      handleCreateReport,
                      showCalendar,
                      setShowCalendar,
                      handleDateChange
                    }) {
  const createBtnDisabled = vehicleType === '' || pp === ''
    || tripDate === '' || startHour === ''
    || startMin === '' || firstBorderHour === '' || firstBorderMin === ''
    || secondBorderHour === '' || secondBorderMin === '' || total === ''

  const dateStyle = () => {
    return showCalendar ? {"display": "none"} : {"display": "flex"}
  }

  const timeStyle = () => {
    return {"display": "flex"}
  }

  return (
    <div>
      <Header as='h1' textAlign='center'>Отчёт о Поездке</Header>
      <Grid textAlign='center'>
        <Grid.Column style={{maxWidth: 450}}>
          <Form size='large' onSubmit={handleCreateReport}>
            <Segment>
              <Form.Dropdown
                label='Граница'
                selection
                name='pp'
                options={ppTypes}
                value={pp}
                onChange={handleInputChange}
              />
              <Form.Dropdown
                label='Транспорт'
                selection
                name='vehicleType'
                options={vehicleTypes}
                value={vehicleType}
                onChange={handleInputChange}
              />
              <Form.Input
                style={dateStyle()}
                label='Укажите дату'
                value={tripDate}
                onFocus={() => setShowCalendar(true)}
              />
              <Calendar
                className={showCalendar ? "" : "hide"}
                name='tripDate'
                onChange={handleDateChange}
                value={tripDate}
              />
              <Form.Dropdown
                label='Приехали на границу'
                selection
                name='startHour'
                options={tripHours}
                value={startHour}
                onChange={handleInputChange}
              />
              <Form.Dropdown
                selection
                label=' '
                name='startMin'
                options={tripMins}
                value={startMin}
                onChange={handleInputChange}
              />
              <Form.Dropdown
                label='Прошли первую границу'
                selection
                name='firstBorderHour'
                options={tripHours}
                value={firstBorderHour}
                onChange={handleInputChange}
              />
              <Form.Dropdown
                selection
                label=' '
                name='firstBorderMin'
                options={tripMins}
                value={firstBorderMin}
                onChange={handleInputChange}
              />
              <Form.Dropdown
                label='Прошли вторую границу'
                selection
                name='secondBorderHour'
                options={tripHours}
                value={secondBorderHour}
                onChange={handleInputChange}
              />
              <Form.Dropdown
                selection
                label=' '
                name='secondBorderMin'
                options={tripMins}
                value={secondBorderMin}
                onChange={handleInputChange}
              />
              <Form.Input
                label='Итого время в пути (в часах)'
                name='total'
                value={total}
                onChange={handleInputChange}
              />
              <Form.TextArea
                label='Дополнительная информация'
                name={'notes'}
                value={notes}
                onChange={handleInputChange}
              />
              <Button icon fluid size='large' color='blue' disabled={createBtnDisabled}>
                Сохранить
              </Button>
            </Segment>
          </Form>
        </Grid.Column>
      </Grid>
    </div>
  )
}

export default ReportForm
